import { render, staticRenderFns } from "./quesGuide8.vue?vue&type=template&id=33a585be"
import script from "./quesGuide8.vue?vue&type=script&lang=js"
export * from "./quesGuide8.vue?vue&type=script&lang=js"
import style0 from "./quesGuide8.vue?vue&type=style&index=0&id=33a585be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports